import { Spinner } from 'components/common'
import { ConfigurationForm } from 'components/configuration'
import ConfigNav from 'components/configuration/configurationNav'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { ConfigurationWithId } from 'types/configuration'
import { fetchConfigurations } from 'utils/api/configApi'
import { ERROR_CODES } from 'utils/constants'

const Configurations = () => {
  const [configuration, setConfiguration] = useState<ConfigurationWithId>()

  const [loading, setLoading] = useState<boolean>(true)
  const [isConfigured, setIsConfigured] = useState<boolean>(true)

  const completeConfiguration = () => {
    setIsConfigured(true)
  }

  const getConfig = async () => {
    try {
      const { data } = await fetchConfigurations()
      if (data.msg === ERROR_CODES.NO_CONFIG_FOUND) {
        setIsConfigured(false)
      } else {
        setConfiguration(data)
      }
    } catch (error) {
      /* empty */
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getConfig()
  }, [isConfigured])

  if (loading) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Spinner size="large" />
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Configurations</title>
      </Helmet>

      <ConfigNav />

      <ConfigurationForm
        isConfigured={isConfigured}
        configuration={configuration}
        completeConfiguration={completeConfiguration}
      />
    </>
  )
}

export default Configurations
